<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import appConfig from "@/app.config";
import MaskedInput from "vue-text-mask";
import Loader from "@/components/widgets/loader";
import { required, minValue } from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.component("v-select", vSelect);

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Créditos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    DatePicker,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      metodos_pagando: {
        monto_efectivo: "",
        monto_cheque: [],
        monto_transferencia: [],
      },
      fechaN: new Date(),
      cantidad_efectivo: "",
      transferencia: {
        cantidad_transferencia: "",
        transaccion_transferencia: "",
      },
      cheque: {
        cantidad_cheque: "",
        transaccion_cheque: "",
      },
      checkMoney: {
        efectivo: false,
        cheque: false,
        transferencia: false,
      },
      checkSelect: {
        efectivo: false,
        cheque: false,
        transferencia: false,
      },
      montoFinal: {
        cantidad: 0,
        metodo: "",
        transaccion: "",
      },
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      metododeBusqueda: false,
      fecha_inicio: "",
      rangode_fecha: "",
      fecha_fin: "",
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "creditos/get",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formCre: {
        nombre: "",
        saldo: 0,
        id: 0,
        metodo:"",
        transaccion:""
      },
      tiendasData: [],
      updating: false,
      estadotabla: true,
      title: "Créditos",
      itemst: [
        {
          text: "Compras",
          href: "/",
        },
        {
          text: "Créditos",
          active: true,
        },
      ],
      fields: [
        {
          name: "no_documento_c",
          title: "No. Documento",
          sortField: "no_documento_c",
          width: "5%",
        },
        {
          name: "no_factura_c",
          title: "No. Factura",
          sortField: "no_factura_c",
          width: "5%",
        },
        {
          name: "empleado",
          title: "Nombre",
          sortField: "empleado",
          width: "15%",
        },
        {
          name: "proveedore.company_proveedor",
          title: "Proveedor",
          sortField: "dproveedore.company_proveedor",
          width: "15%",
        },
        {
          name: "fechac",
          title: "Fecha Compra",
          sortField: "fechac",
          width: "10%",
        },
        {
          name: "fechalimite",
          title: "Fecha Limite",
          sortField: "fechalimite",
          width: "10%",
        },
        {
          name: "saldo",
          title: "Saldo",
          sortField: "saldo",
          width: "10%",
        },
        {
          name: "total",
          title: "Total",
          sortField: "total",
          width: "10%",
        },

        {
          name: "estado3",
          title: "Credito",
          titleClass: "",
          dataClass: "text-muted",
          width: "5%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "estado2",
          dataClass: "text-muted",
          width: "5%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "5%",
        },
      ],
      searchType: [
        { nombre: "No. Doc", value: "no_documento" },
        { nombre: "Proveedor", value: "proveedor" },
        { nombre: "Empleado", value: "empleado" },
        { nombre: "Fecha de orden", value: "fecha" },
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_credito",
      sortDesc: false,
      searchLabel: { nombre: "No. Doc", value: "no_documento" },
      filterLabel: { nombre: "No. Doc", value: "no_documento" },
      showModalL: false, //Loading
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    formCre: {
      nombre: { required },
    },
    cantidad_efectivo: {
      required,
      minValue,
    },
    transferencia: {
      cantidad_transferencia: {
        required,
      },
      transaccion_transferencia: {
        required,
      },
    },
    cheque: {
      cantidad_cheque: {
        required,
      },
      transaccion_cheque: {
        required,
      },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();
      this.formCre.metodo="";
      this.formCre.transaccion="";
      // console.log("retroll");
      if (this.formCre.saldo == "" || this.formCre.saldo === "0") {
        // console.log("retroll");
        return;
      } else {
        if (opc == "save") {
          if (
            this.montoFinal.cantidad > 0 &&
            this.montoFinal.cantidad <= this.formCre.saldo &&
            this.montoFinal.metodo === "Efectivo"
          ) {
            this.showModalL = true;
            this.abonar();
          } else if (
            this.montoFinal.cantidad > 0 &&
            this.montoFinal.cantidad <= this.formCre.saldo &&
            this.montoFinal.metodo != "Efectivo" &&
            this.montoFinal.transaccion != ""
          ) {
            this.showModalL = true;

            this.abonar();
          } else {
            Vue.toasted.error(
              "La cantidad ingresada no es correcta",
              this.options
            );
          }
        }
        else if (opc == "ptodo") {
          if(this.montoFinal.metodo==""){
            Vue.toasted.error(
              "Debe seleccionar algun metodo de pago",
              this.options
            );
          }
          else if( this.montoFinal.metodo != "Efectivo" &&this.montoFinal.transaccion == ""){
            Vue.toasted.error(
              "Debe ingresar el numero de transaccion",
              this.options
            );
          }
          else{ 
            if(this.montoFinal.metodo == "Transferencia"){
              this.formCre.metodo="Transferencia";
              this.formCre.transaccion=this.montoFinal.transaccion;
              this.pagar();
            }
            else if(this.montoFinal.metodo == "cheque"){
              this.formCre.metodo="Cheque";
              this.formCre.transaccion=this.montoFinal.transaccion;
              this.pagar();
            }
            else {
              this.formCre.metodo="Efectivo"
              this.pagar();
            }
            
          }
          
        }
      }
    },

    // Funciones para trabajar con detalles

    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // Metodos de pago
    checkboxChange(action) {
      this.$v.$reset();
      if (action == "efectivo" && !this.checkMoney.efectivo) {
        this.checkSelect.transferencia = false;
        this.checkSelect.cheque = false;
        this.cantidad_efectivo = "";
        this.montoFinal = {
          cantidad: "",
          metodo: "",
          transaccion: "",
        };
      } else if (action == "efectivo" && this.checkMoney.efectivo) {
        this.montoFinal.metodo = "Efectivo";
        this.checkSelect.transferencia = true;
        this.checkSelect.cheque = true;
      }

      if (action == "transferencia" && !this.checkMoney.transferencia) {
        this.checkSelect.efectivo = false;
        this.checkSelect.cheque = false;
        this.transferencia = {
          cantidad_transferencia: "",
          transaccion_transferencia: "",
        };
        this.montoFinal = {
          cantidad: "",
          metodo: "",
          transaccion: "",
        };
      } else if (action == "transferencia" && this.checkMoney.transferencia) {
        this.montoFinal.metodo = "Transferencia";
        this.checkSelect.efectivo = true;
        this.checkSelect.cheque = true;
      }

      if (action == "cheque" && !this.checkMoney.cheque) {
        this.checkSelect.efectivo = false;
        this.checkSelect.transferencia = false;
        this.cheque = {
          cantidad_cheque: "",
          transaccion_cheque: "",
        };
        this.montoFinal = {
          cantidad: "",
          metodo: "",
          transaccion: "",
        };
      } else if (action == "cheque" && this.checkMoney.cheque) {
        this.montoFinal.metodo = "cheque";
        this.checkSelect.efectivo = true;
        this.checkSelect.transferencia = true;
      }
    },
    sumarCantidades(accion, cantidad) {
      if (accion == 1) {
        this.montoFinal.cantidad = parseFloat(
          this.converMaskToNumberxd(cantidad)
        );
      } else {
        this.montoFinal.transaccion = cantidad;
      }
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    limpiarfiltro() {
      let me = this;
      me.fecha_inicio = "";
      me.fecha_fin = "";
    },
    separarfechas() {
      this.fecha_inicio = this.rangode_fecha[0];
      this.fecha_fin = this.rangode_fecha[1];
    },
    activarBuscadorFechas(search, index) {
      this.metododeBusqueda = index == 3 ? true : false;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },

    //Desactivar registro
    pagar() {
      const { id, nombre,metodo,transaccion } = this.formCre;
      axios
        .put(
          process.env.VUE_APP_URL + "creditos/desactivate",
          {
            id: id,
            metodo:metodo,
            transaccion:transaccion
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(
            "Factura: " + nombre + " Compra Pagada",
            this.options
          );
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },
    arrayMetodos() {
      this.metodos_pagando = {
        monto_efectivo: "",
        monto_cheque: [],
        monto_transferencia: [],
      };
      if (this.montoFinal.metodo === "Efectivo") {
        this.metodos_pagando.monto_efectivo = parseFloat(
          this.montoFinal.cantidad
        );
      } else if (this.montoFinal.metodo === "Transferencia") {
        this.metodos_pagando.monto_transferencia.push({
          monto_transferencia: parseFloat(this.montoFinal.cantidad),
          transaccion_transferencia: this.montoFinal.transaccion,
        });
      } else if (this.montoFinal.metodo === "cheque") {
        this.metodos_pagando.monto_cheque.push({
          monto_cheque: parseFloat(this.montoFinal.cantidad),
          transaccion_cheque: this.montoFinal.transaccion,
        });
      }
      return this.metodos_pagando;
    },
    //Pagar  la deuda con  cierta parte de la cantidad o toda
    abonar() {
      const { id, nombre, saldo } = this.formCre;
      const pagadaTotal = saldo == this.montoFinal.cantidad ? 1 : 0;
      const fecha = this.customFormatter(this.fechaN);
      const metodosT = this.arrayMetodos();
      axios
        .put(
          process.env.VUE_APP_URL + "creditos/update",
          {
            id: id,
            metodos_pago: metodosT,
            total_pagado: this.montoFinal.cantidad,
            estado: pagadaTotal,
            fecha,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalA = false;
          this.showModalL = false;
          Vue.toasted.info("Abono: " + nombre + " Asignado", this.options);
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para abonar", this.options);
        })
        .finally(() => {
          this.metodos_pagando = {
            monto_efectivo: "",
            monto_cheque: [],
            monto_transferencia: [],
          };
        });
    },

    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
      console.log(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    async changeTypeDates() {
      await this.separarfechas();
      // console.log(this.fecha_inicio, this.fecha_fin);
      this.$refs.vuetable.refresh();
    },
    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.fecha_inicio = type.value == "fecha" ? "" : "";
      this.fecha_fin = type.value == "fecha" ? "" : "";
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();
          // console.log("limpiando variables");

          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.montoFinal.metodo = "";
      this.montoFinal.transaccion = "";
      this.montoFinal.cantidad = 0;
      this.checkMoney = {
        efectivo: false,
        cheque: false,
        transferencia: false,
      };
      this.checkSelect = {
        efectivo: false,
        cheque: false,
        transferencia: false,
      };
      this.cheque = {
        cantidad_cheque: "",
        transaccion_cheque: "",
      };

      this.transferencia = {
        cantidad_transferencia: "",
        transaccion_transferencia: "",
      };
      this.cantidad_efectivo = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "desactivate-item") {
        this.formCre.nombre = data.no_factura_c;
        this.formCre.id = data.id;
        this.formCre.saldo = data.saldo_credito_c;
        this.showModalD = true;
      }
      if (action == "abonar-item") {
        this.formCre.nombre = data.no_factura_c;
        this.formCre.id = data.id;
        this.formCre.saldo = data.saldo_credito_c;
        this.showModalA = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Actualizar creditos -->
        <b-modal
          centered
          v-model="showModalA"
          @show="openModal('save')"
          @hidden="openModal('save')"
          size="lg"
          title="Abonar Crédito"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <!-- Metodos de pago -->
                  <b-tabs pills vertical nav-wrapper-class="w-50">
                    <!-- Efectivo -->
                    <b-tab :disabled="checkSelect.efectivo">
                      <template v-slot:title>
                        <b-form-checkbox v-model="checkMoney.efectivo">
                          &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                            Efectivo</span
                          >&nbsp;
                          <i class="fas fa-money-bill"> </i>
                        </b-form-checkbox>
                      </template>

                      <b-card bg-variant="primary bg-soft">
                        <b-form-checkbox
                          v-model="checkMoney.efectivo"
                          @input="checkboxChange('efectivo')"
                          >&nbsp;&nbsp;Usar método de pago
                        </b-form-checkbox>
                        <br />
                        <b-form-group label="MONTO">
                          <masked-input
                            :disabled="!checkMoney.efectivo"
                            v-model.trim="$v.cantidad_efectivo.$model"
                            :mask="mask_quetzal"
                            :guide="false"
                            :keep-char-positions="true"
                            :show-mask="true"
                            type="text"
                            @input="sumarCantidades(1, cantidad_efectivo)"
                            placeholder="Ingresar el monto a pagar"
                            :class="{
                              'is-invalid': $v.cantidad_efectivo.$error,
                            }"
                            class="form-control"
                          />
                          <div
                            v-if="checkMoney.efectivo"
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.cantidad_efectivo.$invalid &&
                                !$v.cantidad_efectivo.$invalid.required,
                            }"
                          >
                            Debe ingresar el monto
                          </div>
                        </b-form-group>
                      </b-card>
                    </b-tab>
                    <!-- Transferencia -->
                    <b-tab :disabled="checkSelect.transferencia">
                      <template v-slot:title>
                        <b-form-checkbox v-model="checkMoney.transferencia">
                          &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                            Transferencias</span
                          >&nbsp;
                          <i class="far fa-handshake"> </i>
                        </b-form-checkbox>
                      </template>

                      <b-card bg-variant="primary bg-soft">
                        <b-form-checkbox
                          v-model="checkMoney.transferencia"
                          @input="checkboxChange('transferencia')"
                          >&nbsp;&nbsp;Usar método de pago
                        </b-form-checkbox>
                        <br />
                        <b-form-group label="NÚMERO DE TRANSACCIÓN">
                          <b-form-input
                            :disabled="!checkMoney.transferencia"
                            :class="{
                              'is-invalid':
                                $v.transferencia.transaccion_transferencia
                                  .$error,
                            }"
                            v-model.trim="
                              $v.transferencia.transaccion_transferencia.$model
                            "
                            placeholder="Ingresar en número de transacción"
                            @input="
                              sumarCantidades(
                                2,
                                transferencia.transaccion_transferencia
                              )
                            "
                          >
                          </b-form-input>
                          <div
                            v-if="checkMoney.transferencia"
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.transferencia.transaccion_transferencia
                                  .$invalid &&
                                !$v.transferencia.transaccion_transferencia
                                  .$invalid.required,
                            }"
                          >
                            Debe ingresar el número de transacción
                          </div>
                        </b-form-group>
                        <br />
                        <b-form-group label="MONTO">
                          <masked-input
                            :disabled="!checkMoney.transferencia"
                            v-model.trim="
                              $v.transferencia.cantidad_transferencia.$model
                            "
                            :mask="mask_quetzal"
                            :guide="false"
                            :keep-char-positions="true"
                            :show-mask="true"
                            type="text"
                            @input="
                              sumarCantidades(
                                1,
                                transferencia.cantidad_transferencia
                              )
                            "
                            placeholder="Ingresar el monto a pagar"
                            :class="{
                              'is-invalid':
                                $v.transferencia.cantidad_transferencia.$error,
                            }"
                            class="form-control"
                          />
                          <div
                            v-if="checkMoney.transferencia"
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.transferencia.cantidad_transferencia
                                  .$invalid &&
                                !$v.transferencia.cantidad_transferencia
                                  .$invalid.required,
                            }"
                          >
                            Debe ingresar el monto
                          </div>
                        </b-form-group>
                      </b-card>
                    </b-tab>
                    <!-- cheque -->
                    <b-tab :disabled="checkSelect.cheque">
                      <template v-slot:title>
                        <b-form-checkbox v-model="checkMoney.cheque">
                          &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                            Cheques</span
                          >&nbsp;
                          <i class="far fa-credit-card"> </i>
                        </b-form-checkbox>
                      </template>

                      <b-card bg-variant="primary bg-soft">
                        <b-form-checkbox
                          v-model="checkMoney.cheque"
                          @input="checkboxChange('cheque')"
                          >&nbsp;&nbsp;Usar método de pago
                        </b-form-checkbox>
                        <br />
                        <b-form-group label="NÚMERO DE CHEQUE">
                          <b-form-input
                            :disabled="!checkMoney.cheque"
                            v-model.trim="$v.cheque.transaccion_cheque.$model"
                            placeholder="Ingresar en número de transacción"
                            @input="
                              sumarCantidades(2, cheque.transaccion_cheque)
                            "
                            :class="{
                              'is-invalid':
                                $v.cheque.transaccion_cheque.$error,
                            }"
                          >
                          </b-form-input>
                          <div
                            v-if="checkMoney.cheque"
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.cheque.transaccion_cheque.$invalid &&
                                !$v.cheque.transaccion_cheque.$invalid
                                  .required,
                            }"
                          >
                            Debe ingresar el número de transacción
                          </div>
                        </b-form-group>
                        <br />
                        <b-form-group label="MONTO">
                          <masked-input
                            :disabled="!checkMoney.cheque"
                            v-model.trim="$v.cheque.cantidad_cheque.$model"
                            :mask="mask_quetzal"
                            :guide="false"
                            :keep-char-positions="true"
                            :show-mask="true"
                            type="text"
                            @input="
                              sumarCantidades(1, cheque.cantidad_cheque)
                            "
                            placeholder="Ingresar el monto a pagar"
                            :class="{
                              'is-invalid': $v.cheque.cantidad_cheque.$error,
                            }"
                            class="form-control"
                          />
                          <div
                            v-if="checkMoney.cheque"
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.cheque.cantidad_cheque.$invalid &&
                                !$v.cheque.cantidad_cheque.$invalid.required,
                            }"
                          >
                            Debe ingresar el monto
                          </div>
                        </b-form-group>
                      </b-card>
                    </b-tab>
                  </b-tabs>
                  <br />
                  <div class="row">
                    <div class="col">
                      <b-card
                        bg-variant="primary"
                        class="text-white-50 bg-gradient"
                      >
                        <h2 class="mt-0 mb-4 text-white">
                          <i class="bx bx-list-check me-3"></i> Total Deuda
                        </h2>
                        <h3 class="mt-0 mb-4 text-white" align="center">
                          {{ money(formCre.saldo) }}
                        </h3>
                      </b-card>
                    </div>
                    <div class="col">
                      <b-card
                        bg-variant="primary"
                        class="text-white-50 bg-gradient"
                      >
                        <h2 class="mt-0 mb-4 text-white">
                          <i class="bx bx-detail me-3"></i> Cantidad a pagar
                        </h2>
                        <h3 class="mt-0 mb-4 text-white" align="center">
                          {{
                            money(
                              montoFinal.cantidad >= 0
                                ? montoFinal.cantidad
                                : 0.0
                            )
                          }}
                        </h3>
                      </b-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
            <b-button variant="danger" @click="validaciones('save')"
                >Pagar</b-button
              >
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Pagar total"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
        <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <!-- Metodos de pago -->
                  <b-tabs pills vertical nav-wrapper-class="w-50">
                    <!-- Efectivo -->
                    <b-tab :disabled="checkSelect.efectivo">
                      <template v-slot:title>
                        <b-form-checkbox v-model="checkMoney.efectivo">
                          &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                            Efectivo</span
                          >&nbsp;
                          <i class="fas fa-money-bill"> </i>
                        </b-form-checkbox>
                      </template>

                      <b-card bg-variant="primary bg-soft">
                        <b-form-checkbox
                          v-model="checkMoney.efectivo"
                          @input="checkboxChange('efectivo')"
                          >&nbsp;&nbsp;Usar método de pago
                        </b-form-checkbox>
                        <br />
                      </b-card>
                    </b-tab>
                    <!-- Transferencia -->
                    <b-tab :disabled="checkSelect.transferencia">
                      <template v-slot:title>
                        <b-form-checkbox v-model="checkMoney.transferencia">
                          &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                            Transferencias</span
                          >&nbsp;
                          <i class="far fa-handshake"> </i>
                        </b-form-checkbox>
                      </template>

                      <b-card bg-variant="primary bg-soft">
                        <b-form-checkbox
                          v-model="checkMoney.transferencia"
                          @input="checkboxChange('transferencia')"
                          >&nbsp;&nbsp;Usar método de pago
                        </b-form-checkbox>
                        <br />
                        <b-form-group label="NÚMERO DE TRANSACCIÓN">
                          <b-form-input
                            :disabled="!checkMoney.transferencia"
                            :class="{
                              'is-invalid':
                                $v.transferencia.transaccion_transferencia
                                  .$error,
                            }"
                            v-model.trim="
                              $v.transferencia.transaccion_transferencia.$model
                            "
                            placeholder="Ingresar en número de transacción"
                            @input="
                              sumarCantidades(
                                2,
                                transferencia.transaccion_transferencia
                              )
                            "
                          >
                          </b-form-input>
                          <div
                            v-if="checkMoney.transferencia"
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.transferencia.transaccion_transferencia
                                  .$invalid &&
                                !$v.transferencia.transaccion_transferencia
                                  .$invalid.required,
                            }"
                          >
                            Debe ingresar el número de transacción
                          </div>
                        </b-form-group>
                        <br />
                      </b-card>
                    </b-tab>
                    <!-- cheque -->
                    <b-tab :disabled="checkSelect.cheque">
                      <template v-slot:title>
                        <b-form-checkbox v-model="checkMoney.cheque">
                          &nbsp;&nbsp;<span class="d-none d-sm-inline-block">
                            Cheques</span
                          >&nbsp;
                          <i class="far fa-credit-card"> </i>
                        </b-form-checkbox>
                      </template>

                      <b-card bg-variant="primary bg-soft">
                        <b-form-checkbox
                          v-model="checkMoney.cheque"
                          @input="checkboxChange('cheque')"
                          >&nbsp;&nbsp;Usar método de pago
                        </b-form-checkbox>
                        <br />
                        <b-form-group label="NÚMERO DE CHEQUE">
                          <b-form-input
                            :disabled="!checkMoney.cheque"
                            v-model.trim="$v.cheque.transaccion_cheque.$model"
                            placeholder="Ingresar en número de transacción"
                            @input="
                              sumarCantidades(2, cheque.transaccion_cheque)
                            "
                            :class="{
                              'is-invalid':
                                $v.cheque.transaccion_cheque.$error,
                            }"
                          >
                          </b-form-input>
                          <div
                            v-if="checkMoney.cheque"
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.cheque.transaccion_cheque.$invalid &&
                                !$v.cheque.transaccion_cheque.$invalid
                                  .required,
                            }"
                          >
                            Debe ingresar el número de transacción
                          </div>
                        </b-form-group>
                        <br />
                      </b-card>
                    </b-tab>
                  </b-tabs>
                  <br />
                  <div class="row">
                    <div class="col">
                      <b-card
                        bg-variant="primary"
                        class="text-white-50 bg-gradient"
                      >
                        <h2 class="mt-0 mb-4 text-white">
                          <i class="bx bx-list-check me-3"></i> Total Deuda
                        </h2>
                        <h3 class="mt-0 mb-4 text-white" align="center">
                          {{ money(formCre.saldo) }}
                        </h3>
                      </b-card>
                    </div>
                    <div class="col">
                      <b-card
                        bg-variant="primary"
                        class="text-white-50 bg-gradient"
                      >
                        <h2 class="mt-0 mb-4 text-white">
                          <i class="bx bx-detail me-3"></i> Cantidad a pagar
                        </h2>
                        <h3 class="mt-0 mb-4 text-white" align="center">
                          {{
                            money(
                              formCre.saldo
                            )
                          }}
                        </h3>
                      </b-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="validaciones('ptodo')">Pagar todo</b-button>
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de creditos</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(search, index) in searchType"
                        :key="index"
                        @click="
                          changeTypeSearch(search);
                          activarBuscadorFechas(search, index);
                          limpiarfiltro();
                        "
                        >{{ search.nombre }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-3" v-if="metododeBusqueda">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <date-picker
                      v-model="rangode_fecha"
                      range
                      append-to-body
                      lang="en"
                      confirm
                      confirm-text="Aceptar"
                      @input="changeTypeDates()"
                    ></date-picker>
                  </label>
                </div>
              </div>

              <div
                class="col-sm-12 col-md-3 text-md-start"
                v-if="metododeBusqueda == false"
              >
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      @input="onFiltered()"
                      placeholder="Buscar..."
                      class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center"> </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-url="apiBase"
                :http-options="httpOptions"
                :reactive-api-url="true"
                :fields="fields"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <router-link
                      :to="{
                        name: 'vistacreditos',
                        params: { id: props.rowData.id },
                      }"
                    >
                      <b-button
                        v-if="props.rowData.estado_compra"
                        tabindex="0"
                        v-b-tooltip.focus
                        title="Ver mas"
                        variant="outline-primary"
                        ><i class="bx bxs-show"></i>
                      </b-button>
                    </router-link>
                    <b-button
                      tabindex="0"
                      v-if="
                        props.rowData.estado_compra &&
                        props.rowData.saldo_credito_c > 0
                      "
                      v-b-tooltip.focus
                      title="Cancelar Crédito"
                      variant="outline-danger"
                      @click="
                        onActionClicked('desactivate-item', props.rowData)
                      "
                    >
                      <i class="fas fa-money-bill-wave"></i>
                    </b-button>
                    <b-button
                      tabindex="0"
                      v-if="
                        props.rowData.estado_compra &&
                        props.rowData.saldo_credito_c > 0
                      "
                      v-b-tooltip.focus
                      title="Abonar Crédito"
                      variant="outline-info"
                      @click="
                        onActionClicked('abonar-item', props.rowData)
                      "
                    >
                      <i class="fas fa-money-check-alt"></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_compra == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="empleado" slot-scope="props">
                  {{ props.rowData.user.empleado.persona.nombre_persona }}
                  {{ props.rowData.user.empleado.persona.apellido_persona }}
                </div>
                <div slot="estado3" slot-scope="props">
                  <h5 v-if="props.rowData.estado_pagado_c == true">
                    <span class="badge bg-success ms-1"
                      ><strong>Pagado</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>Pendiente</strong></span
                    >
                  </h5>
                </div>
                <!-- <div slot="usuario" slot-scope="props">
                  <h6 v-if="props.rowData.estado_autoriza == false">
                    {{ props.rowData.usuario_autoriza.usuario }}
                  </h6>
                  <h6 v-else>Sin Autorizar</h6>
                </div> -->

                <div slot="fechac" slot-scope="props">
                  {{ showDate(props.rowData.fecha_compra) }}
                </div>

                <div slot="fechalimite" slot-scope="props">
                  {{ showDate(props.rowData.fecha_credito_c) }}
                </div>
                <div slot="saldo" slot-scope="props">
                  {{ money(props.rowData.saldo_credito_c) }}
                </div>
                <div slot="total" slot-scope="props">
                  {{ money(props.rowData.total_c) }}
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
